module.exports = __webpack_public_path__ + "img/home-illustration1.124c97d6.svg";